import _classCallCheck from "D:\\Projects\\say-more-financial-service-admin-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\say-more-financial-service-admin-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

var t = function t(_t, e) {
  return new Promise(function (r, o) {
    try {
      var _o = _t();

      e && e(null, _o), r(_o);
    } catch (t) {
      e && e(t), o(t);
    }
  });
},
    e = function e(t, _e, r) {
  return Promise.all(t).then(function (t) {
    var o = r ? r(t) : null;
    return _e && _e(null, o), Promise.resolve(o);
  }, function (t) {
    return _e && _e(t), Promise.reject(t);
  });
};

var r =
/*#__PURE__*/
function () {
  function r() {
    _classCallCheck(this, r);
  }

  _createClass(r, null, [{
    key: "setItem",
    value: function setItem(e, r, o) {
      return t(function () {
        window.localStorage.setItem(e, r);
      }, o);
    }
  }, {
    key: "getItem",
    value: function getItem(e, r) {
      return t(function () {
        return window.localStorage.getItem(e);
      }, r);
    }
  }, {
    key: "removeItem",
    value: function removeItem(e, r) {
      return t(function () {
        return window.localStorage.removeItem(e);
      }, r);
    }
  }, {
    key: "clearStorage",
    value: function clearStorage(e) {
      return t(function () {
        window.localStorage.clear();
      }, e);
    }
  }, {
    key: "getKeys",
    value: function getKeys(e) {
      return t(function () {
        var t = window.localStorage.length,
            e = [];

        for (var _r = 0; _r < t; _r += 1) {
          var _t2 = window.localStorage.key(_r);

          e.push(_t2);
        }

        return e;
      }, e);
    }
  }, {
    key: "setMultiple",
    value: function setMultiple(t, o) {
      var n = t.map(function (t) {
        for (var _e2 in t) {
          r.setItem(_e2, t[_e2]);
        }
      });
      return e(n, o);
    }
  }, {
    key: "getMultiple",
    value: function getMultiple(t, o) {
      var n = t.map(function (t) {
        return r.getItem(t);
      });
      return e(n, o, function (e) {
        return e.map(function (e, r) {
          var o = {};
          return o[t[r]] = e, o;
        });
      });
    }
  }, {
    key: "removeMultiple",
    value: function removeMultiple(t, o) {
      var n = t.map(function (t) {
        return r.removeItem(t);
      });
      return e(n, o);
    }
  }]);

  return r;
}();

export default r;